import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO31 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK003-1.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO31
